<template>
  <div>
    <div class="text-red mb-6 text-2sm pr-3 leading-snug">
      {{ $t('confirmText') }}
    </div>
    <BaseButton theme="red"
                :disabled="sending || sent"
                class="w-full"
                @click="sendMain">
      <span v-if="!sending && !sent">{{ $t('resendLabel') }}</span>
      <font-awesome-icon v-else-if="sending && !sent" icon="circle-notch" spin/>
      <font-awesome-icon v-else-if="sent" icon="check"/>
    </BaseButton>
  </div>

</template>

<script>
import {mapActions} from "vuex";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "ConfirmEmail",
  components: {
    BaseButton,
  },
  data() {
    return {
      sending: false,
      sent: false
    }
  },
  methods: {
    ...mapActions('cabinet/user', ['sendConfirmEmail']),
    sendMain() {
      this.sending = true;
      this.sendConfirmEmail().then((res) => {
        if (res.body.success) {
          this.sent = true;
          this.$toasted.success('Письмо отправлено!')
        } else {
          this.sent = false;
          this.sending = false;
          this.$toasted.error('Произошла ошибка')
        }
      });
    }
  },
  i18n: {
    messages: {
      en: {
        confirmText: 'Your email hasn\'t been verified. Check your email or resend your email.',
        resendLabel: 'Resend e-mail'
      },
      ru: {
        confirmText: 'Ваш e-mail не подтвержден. Проверьте почту или отправьте письмо повторно.',
        resendLabel: 'Отправить письмо повторно'
      }
    }
  }

}
</script>